/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCurrencyYenOff = createReactComponent("currency-yen-off", "IconCurrencyYenOff", [
  ["path", { d: "M12 19v-7m5 -7l-3.328 4.66", key: "svg-0" }],
  ["path", { d: "M8 17h8", key: "svg-1" }],
  ["path", { d: "M8 13h5", key: "svg-2" }],
  ["path", { d: "M3 3l18 18", key: "svg-3" }]
]);

export { IconCurrencyYenOff as default };
//# sourceMappingURL=IconCurrencyYenOff.js.map
